import { render, staticRenderFns } from "./ListaAdminInstitucion.vue?vue&type=template&id=752088c6&"
import script from "./ListaAdminInstitucion.vue?vue&type=script&lang=js&"
export * from "./ListaAdminInstitucion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports